module.exports = __webpack_public_path__ + "img/CD03.56ee6247.png";